import { useAppSelector } from '@/redux/hooks'
import { Base, SuccessIcon } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import { useSendProductRequest } from '@/application/send-product-request'

interface FeatureProps {
  title: string
  layout: React.ReactNode
}

export const Feature: React.FC<FeatureProps> = ({ title, layout }) => {
  const { t } = useTranslation()
  const email =
    useAppSelector((store) => store.userApi.getMe.response.user?.name) ?? ''
  const { sendProductRequest, isLoading, error, success } =
    useSendProductRequest()

  const handleClickRequest = () => {
    sendProductRequest({
      email,
      featureText: title,
      source: 'store'
    })
  }

  return (
    <div className="group flex h-48 flex-col justify-center overflow-hidden rounded-xl bg-white p-6 shadow transition-all hover:shadow-lg">
      {layout}
      {isLoading ? (
        <div className="flex w-full items-center justify-center">
          <Base.Spinner
            label={t('rever_store.sending_request')}
            className="m-2 mt-4"
          />
        </div>
      ) : success ? (
        <div className="-ml-2 flex w-full items-center justify-center">
          <SuccessIcon className="m-2 size-6" />
          <p className="text-sm font-thin text-gray-400">
            You’re on the list! We’ll send you set up details shortly.
          </p>
        </div>
      ) : error ? (
        <div className="flex w-full items-center justify-center text-red-500">
          <p className="text-sm font-thin ">
            Something went wrong. Please try again.
          </p>
        </div>
      ) : (
        <button
          onClick={handleClickRequest}
          className="font-base mx-auto w-fit rounded-full border border-solid border-gray-300 px-8 py-1 text-sm text-gray-600 transition-all hover:bg-gray-100 hover:shadow"
        >
          <p>Get early access</p>
        </button>
      )}
    </div>
  )
}
